module.exports = __webpack_public_path__ + "static/img/qdhf4.f2037ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qdhf4.jpg
// module id = Vexs
// module chunks = 0